import { TbCloudDownload } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { DownloadedModules, updateDownloadTriggered } from "../../store/Utilities";
import { RootState, persistor } from "../../store/store";

import storeAllUsers from "./storeAllUsers";
import storeCategories from "./storeCategories";
import { storeChangeLogs } from "./storeChangeLogs";
import { storeComments } from "./storeComments";
import storeDisciplinePunchList from "./storeDisciplinePunchList2";
import storeDisciplines from "./storeDisciplines";
import storeDrawings from "./storeDrawings";
import storeDrilldownMappings from "./storeDrilldownMappings";
import storeIssues from "./storeIssues";
import storeLinkDisciplineTechCategory from "./storeLinkDesciplineTechCategory";
import storeLinkDisciplineIssue from "./storeLinkDiscplineIssue";
import storeModels from "./storeModels";
import storeProjects from "./storeProjects";
import storeRelatedChecklistDetails from "./storeRelatedChecklistDetails";
import storeRootCauses from "./storeRootCauses";
import storeStatus from "./storeStatus";
import storeTasks from "./storeTasks";
import storeTechnology from "./storeTechnology";
import { storeChangeLogsTypes } from "./storechangelogsTypes";
import storeRegions from "./storeRegions";
import storeOnHoldCauses from "./storeOnHoldCauses";
import storeBusinessUnites from "./storeBusinessUnites";
import storeAccessLevel from "./storeAccessLevel";

export function DownloadUserRelatedData() {

    // downloading order matters !!!

    /**
     * once optione
     * retrigger
     * keep notSync data  
    */

    const { isloading: isIssuesLoading } = storeIssues();
    const { isloading: isStatusLoading } = storeStatus();
    const { isloading: isRootCausesLoading } = storeRootCauses();
    const { isloading: isTechnologyLoading } = storeTechnology();
    const { isloading: isRegionsLoading } = storeRegions();
    const { isloading: isCategoriesLoading } = storeCategories();
    const { isloading: isLogsTypesLoading } = storeChangeLogsTypes();
    const { isloading: isDrilldownMappingsLoading } = storeDrilldownMappings();
    // TODO: remove these options if we agreed to keep the dd01 as text in punchlist form
    // const { isloading: isPunchlistOptionsLevelOneLoading } = storeDD1();
    const { isloading: isLinkDisciplineIssueLoading } = storeLinkDisciplineIssue();
    const { isloading: isLinkDisciplineTechCategoryLoading } = storeLinkDisciplineTechCategory();
    const { isloading: isOnHoldCausesLoading } = storeOnHoldCauses();
    const { isloading: isBusinessUnitsLoading } = storeBusinessUnites();
    const { isloading: isAccessLevelsLoading } = storeAccessLevel();

    // TODO: remove these options if we agreed to keep the dd02 as text in punchlist form
    // const { isloading: isPunchlistOptionsLevelTwoLoading } = storeDD2();

    // chained
    const { isloading: isProjectsLoading } = storeProjects();
    const { isloading: isDisciplineLoading } = storeDisciplines();
    const { isloading: isFilesLoading } = storeDrawings();
    const { isLoading: isUsersLoading } = storeAllUsers();
    const { isloading: isCommentsLoading } = storeComments();
    const { isLoading: isTasksLoading } = storeTasks()
    const { isloading: isLogsLoading } = storeChangeLogs();

    const { isLoading: isModelsLoading } = storeModels();
    const { isloading: isRelatedChecklistDetailsLoading } = storeRelatedChecklistDetails();
    const { isloading: isPunchlistLoading, isPhotosLoading: isPunchlistImagesLoading } = storeDisciplinePunchList();

    // Add any new stored files to src\components\CoreComponents\Loader.tsx in order to give it a nickname / lodading display name
    return {
        isIssuesLoading,
        isProjectsLoading,
        isFilesLoading,
        isLogsTypesLoading,
        isDisciplineLoading,
        isUsersLoading,
        isAccessLevelsLoading,
        isCommentsLoading,
        isStatusLoading,
        isCategoriesLoading,
        isLogsLoading,
        isAdHocUnitsLoading: false,
        isModelsLoading,
        isRelatedChecklistDetailsLoading,
        isDrilldownMappingsLoading,
        isPunchlistLoading,
        isPunchlistImagesLoading,
        isTasksLoading,
        isPunchlistOptionsLevelOneLoading: false,
        isPunchlistOptionsLevelTwoLoading: false,
        isRootCausesLoading,
        isLinkDisciplineIssueLoading,
        isLinkDisciplineTechCategoryLoading,
        isTechnologyLoading,
        isRegionsLoading,
        isOnHoldCausesLoading,
        isBusinessUnitsLoading,
    }
}

export default function Downloaded({ modules }: { modules?: DownloadedModules }) {
    const dispatch = useDispatch()
    const { unsyncItemsCount } = useSelector(
        (state: RootState) => state.Utilities
    );
    const selectedDownloadTriggered = {
        issues: true, categories: true, drilldownMappings: true,
        changeLogsTypes: true, status: true,
        projects: true, dd1Options: true, dd2Options: true
    }
    return (
        <div
            className="scale-125 cursor-pointer"
            onClick={() => {
                if (unsyncItemsCount !== 0) {
                    toast("Cannot download without sync with backend first!", { type: "error" })
                    return
                }
                persistor.purge().then(() => {
                    Object.keys(modules ?? selectedDownloadTriggered).forEach((key: keyof DownloadedModules) => {
                        dispatch(updateDownloadTriggered({ key: key, value: true }))
                    })
                })
            }}
        >
            <TbCloudDownload />
        </div>
    )
}